import { Reducer } from 'redux';
import { StudentsState, StudentsTypes } from './types';

export const INITIAL_STATE: StudentsState = {
  studentsList: [],
  studentData: {
    id: '',
    name: '',
    document: '',
    email: '',
    phone: '',
    photoUrl: '',
    createdAt: '',
    updatedAt: '',
    schoolCourseId: '',
  },
  totalCount: 0,
  error: false,
  loading: false,
  studentsCheckUsersList: [],
};

const reducer: Reducer<StudentsState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // LIST STUDENTS
    case StudentsTypes.LIST_STUDENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        studentsList: INITIAL_STATE.studentsList,
      };
    case StudentsTypes.LIST_STUDENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        studentsList: action.payload.studentsList,
        totalCount: action.payload.totalCount,
      };
    case StudentsTypes.LIST_STUDENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        studentsList: INITIAL_STATE.studentsList,
      };

    // GET STUDENT
    case StudentsTypes.GET_STUDENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        studentData: INITIAL_STATE.studentData,
      };
    case StudentsTypes.GET_STUDENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        studentData: action.payload.studentData,
      };
    case StudentsTypes.GET_STUDENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        studentData: INITIAL_STATE.studentData,
      };

    // CREATE STUDENT
    case StudentsTypes.CREATE_STUDENT_REQUEST:
      return { ...state, loading: true, error: false };
    case StudentsTypes.CREATE_STUDENT_SUCCESS:
      return { ...state, loading: false, error: false };
    case StudentsTypes.CREATE_STUDENT_FAILURE:
      return { ...state, loading: false, error: true };

    // UPDATE STUDENT
    case StudentsTypes.UPDATE_STUDENT_REQUEST:
      return { ...state, loading: true, error: false };
    case StudentsTypes.UPDATE_STUDENT_SUCCESS:
      return { ...state, loading: false, error: false };
    case StudentsTypes.UPDATE_STUDENT_FAILURE:
      return { ...state, loading: false, error: true };

    // DELETE STUDENT
    case StudentsTypes.DELETE_STUDENT_REQUEST:
      return { ...state, loading: true, error: false };
    case StudentsTypes.DELETE_STUDENT_SUCCESS:
      return { ...state, loading: false, error: false };
    case StudentsTypes.DELETE_STUDENT_FAILURE:
      return { ...state, loading: false, error: true };

    // CREATE STUDENTS
    case StudentsTypes.CREATE_STUDENTS_REQUEST:
      return { ...state, loading: true, error: false };
    case StudentsTypes.CREATE_STUDENTS_SUCCESS:
      return { ...state, loading: false, error: false };
    case StudentsTypes.CREATE_STUDENTS_FAILURE:
      return { ...state, loading: false, error: true };

    // UPDATE STUDENTS
    case StudentsTypes.UPDATE_STUDENTS_REQUEST:
      return { ...state, loading: true, error: false };
    case StudentsTypes.UPDATE_STUDENTS_SUCCESS:
      return { ...state, loading: false, error: false };
    case StudentsTypes.UPDATE_STUDENTS_FAILURE:
      return { ...state, loading: false, error: true };

    // DELETE STUDENTS
    case StudentsTypes.DELETE_STUDENTS_REQUEST:
      return { ...state, loading: true, error: false };
    case StudentsTypes.DELETE_STUDENTS_SUCCESS:
      return { ...state, loading: false, error: false };
    case StudentsTypes.DELETE_STUDENTS_FAILURE:
      return { ...state, loading: false, error: true };

    // CHECK STUDENTS
    case StudentsTypes.CHECK_STUDENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        studentsCheckUsersList: INITIAL_STATE.studentsCheckUsersList,
      };
    case StudentsTypes.CHECK_STUDENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        studentsCheckUsersList: action.payload.studentsCheckUsersList,
      };
    case StudentsTypes.CHECK_STUDENTS_FAILURE:
      return { ...state, loading: false, error: true };

    default:
      return state;
  }
};

export default reducer;
